
  export const style={
    inpuStyle:{
      colorInput:"#6D311B"
    },
    url:{
      urlClient:"https://n360academy.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_client_natuzzi.png",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: true,
       autoRegister: false,
       recaptchaVersion : "V2"
    },
    CurrencyName:{
      name:"Ncoin/Ncoins"
    },
    teamName:{
      name:"Natuzzi"
    },
    hasToken: true,
    hostHeader: "natuzzi"
  }
